import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import { findProjectsForSchool } from '../../project/project-actions';
import ProjectCardList from '../../project/project-card-list/ProjectCardList';
import SchoolSearch from '../../project/project-edit/school/SchoolSearch/SchoolSearch';
import { PRIMARY_ORGANIZATION_COLOR, TERTIARY_ORGANIZATION_COLOR } from '../../organization/theme/OrganizationTheme';
import { ownerType } from '../../skolelop/school-model';
import CreateProjectButton from '../../components/create-project-button/CreateProjectButton';
import { THEMES } from '../../utils/cms-utils';
import styles from './school-projects-for-organization-search.module.less';
import { PROJECT_TYPE_SCHOOL } from '../../project/project-model';
import { Heading2 } from '@sb1/ffe-core-react';

const SchoolProjectsForCauseSearch = ({ type, causeId, createProjectParams, previewOnly, startSpleisButtonText }) => {
    const dispatch = useDispatch();
    const [school, setSchool] = useState(null);
    const [projectsForSchool, setProjectsForSchool] = useState([]);
    const [isSearchingForSchool, setIsSearchingForSchool] = useState(false);

    useEffect(() => {
        const fetchProjects = async () => {
            if (school) {
                setIsSearchingForSchool(true);
                await dispatch(findProjectsForSchool({ schoolId: school?.id, causeId }))
                    .then((projectIds) => {
                        if (projectIds?.length) {
                            setProjectsForSchool(projectIds.map((project) => project.id));
                        } else {
                            setProjectsForSchool([]);
                        }
                    })
                    .catch(() => {})
                    .finally(setIsSearchingForSchool(false));
            } else {
                setProjectsForSchool([]);
            }
        };

        fetchProjects();
    }, [school]);

    return (
        <div className={[styles.outerContainer, TERTIARY_ORGANIZATION_COLOR].join(' ')}>
            <div className={styles.container}>
                <Heading2 lookLike={4} className={styles.header}>
                    Start en spleis for din {ownerType(type)}
                </Heading2>
                <div className={styles.searchText}>
                    Finn din {ownerType(type)} i søket og start en {ownerType(type)}innsamling
                </div>
                <div className={styles.schoolSearchContainer}>
                    <SchoolSearch
                        selectSchoolCallback={(selectedSchool) => {
                            setSchool(selectedSchool?.school);
                        }}
                        type={type}
                        themeColor={THEMES.WHITE}
                    />
                </div>

                {isSearchingForSchool && <LoaderBar />}
                {school && (
                    <CreateProjectButton
                        linkParams={`${
                            createProjectParams ? `${createProjectParams}&` : `?`
                        }type=${PROJECT_TYPE_SCHOOL}&organizationNumber=${school.organizationNumber}`}
                        className={[styles.createButton, PRIMARY_ORGANIZATION_COLOR].join(' ')}
                        disabled={previewOnly}
                    >
                        {startSpleisButtonText || `Start en ${ownerType(type)}innsamling`}
                    </CreateProjectButton>
                )}
                <ProjectCardList
                    className={styles.projectCardWrapper}
                    projectIds={projectsForSchool}
                    limit={50}
                    actionInformation={`Spleiser til ${ownerType(type)}n`}
                    cardTitleHeadingLevel={4}
                />
            </div>
        </div>
    );
};

export default SchoolProjectsForCauseSearch;
